/**
 * Ключ для google pay, выдается после регистрации в Google
 * @type {string}
 */
export const MERCHANT_ID = '04349806409183181471';

/**
 * Формат валюты
 * @type {string}
 */
export const CURRENCY = 'р.';

/**
 * Названия типов доставки
 * @type {{post: string, pvz: string, courier: string}}
 */
export const NAMES_TYPE_DELIVERY = {
  post: 'Почта России',
  pvz: 'Пункты выдачи',
  courier: 'Курьерская доставка',
  free_pvz: 'Пункты выдачи партнеров',
  free_pvz_book24: 'Пункты выдачи Book24',
  free_post: 'Почта России',
  free_courier: 'Курьерская доставка',
};

/**
 * Код наложного платежа почты России
 * @type {string}
 */
export const POST_USUAL_CASH_ON_DELIVERY = 'post_usual_cash_on_delivery';

/**
 * Код бесконтактной доставки
 * @type {string}
 */
export const CONTACTLESS_DELIVERY_CODE = 'manual_msk_courier_outside_msk';

/**
 * Идентификаторы основных регионов
 * @type {*[]}
 */
export const IMPORTANT_LOCATIONS = [
  '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
  'c2deb16a-0330-4f05-821f-1d09c93331e6',
];

/**
 * Максимальное количество товаров для покупки
 * @type {number}
 */
export const MAX_COUNT_CART = 999;

/**
 * Максимальное отображаемое кол-во товаров в малой корзине
 * @type {number}
 */
export const MAX_COUNT_TOP_CART = 99;

/**
 * Минимальное количество при котором показываем сколько товаров осталось
 * @type {number}
 */
export const MIN_QUANTITY_THINGS = 15;

/**
 * @description Текст непредвиденной ошибки
 * @type {string}
 */
export const ERROR_MESSAGE = 'Что-то пошло не так, попробуйте повторить попытку позже';

/**
 * Успешный статус ответа бекенда
 * @type {string}
 */
export const SUCCESS_STATUS = 'OK';

/**
 * Час в миллисекундах
 * @type {number}
 */
export const ONE_HOUR_IN_MS = 60 * 60 * 1000;

/**
 * Месяц в миллисекундах
 * @type {number}
 */
export const MONTH_IN_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * Дефолтный текст ошибки
 * @type {string}
 */
export const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка, попробуйте повторить позднее';

/**
 * Дефолтный пресет для сортировки коментариев в карточке товара
 * @type {[{code: string, title: string}]}
 */
export const SORTING_PRESET_COMMENTS_PRODUCT = [
  {
    value: 'dateCreateDesc',
    label: 'Сначала новые',
  },
  {
    value: 'dateCreateAsc',
    label: 'Сначала старые',
  },
  {
    value: 'ratingDesc',
    label: 'Сначала полезные',
  },
];

/**
 * Электронная почта недоступна для регистрации
 * @type {string}
 */
export const CODE_EMAIL_NO_AVAILABLE = 'af08ef2f-35db-4c13-b0d8-28e3bbb6a5e5';

/**
 * Невалидный адрес электронной почты при проверке email на доступность
 * @type {string}
 */
export const NO_VALID_EMAIL_AVAILABILITY = 'e1420a46-7bf6-44cf-8723-7e57e4925236';

/**
 * Сумма ниже которой показывается сообщение о том что нужно добавить товаров на N руб
 * @type {number}
 */
export const DELIVERY_SUM = 250;

/**
 * @typedef RegionsType
 * @property {string} code - Код ФИАС города
 * @property {string} coords - Координаты центра города
 * @property {string} index - Почтовый индекс города
 * @property {string} name - Название города
 */

/**
 * Список основных регионов с их сводной информацией
 * @readonly
 * @enum {RegionsType}
 * @const
 */
export const MAIN_REGIONS = Object.freeze({
  msk: {
    code: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
    coords: '55.7511564, 37.6223746',
    index: '101000',
    name: 'Москва',
    regionFias: '29251dcf-00a1-4e34-98d4-5c47484a36d4',
    regionFiasList: ['29251dcf-00a1-4e34-98d4-5c47484a36d4', '0c5b2444-70a0-4932-980c-b4dc0d3f02b5'],
  },
  spb: {
    code: 'c2deb16a-0330-4f05-821f-1d09c93331e6',
    coords: '59.939095, 30.315868',
    index: '190000',
    name: 'Санкт-Петербург',
    regionFias: '6d1ebb35-70c6-4129-bd55-da3969658f5d',
    regionFiasList: ['6d1ebb35-70c6-4129-bd55-da3969658f5d', 'c2deb16a-0330-4f05-821f-1d09c93331e6'],
  },
});

/**
 * @typedef TypesDelivery
 * @property {string} code - Код вида доставки
 * @property {string} name - Название вида доставки
 */

/**
 * Список основных типов доставки
 * @readonly
 * @enum {TypesDelivery}
 * @const
 */
export const TYPES_DELIVERY = Object.freeze({
  pvz: {
    code: 'pvz',
    name: 'Пункты выдачи',
  },
  post: {
    code: 'post',
    name: 'Почта России',
  },
  courier: {
    code: 'courier',
    name: 'Курьерская доставка',
  },
  courierPost: {
    code: 'post_online_courier',
    name: 'Курьерская доставка Почтой России',
  },
});

/**
 * Ошибка от cloudpayments если пользователь закрыл окно с оплатой
 * @readonly
 * @string
 * @const
 */
export const CLOUDPAYMENTS_USER_CANCEL_ERROR = 'User has cancelled';

/**
 * Типы платформ
 * @type {Readonly<{desktop: string, mobile: string}>}
 * @const
 */
export const TYPES_PLATFORM = Object.freeze({
  mobile: 'mobile',
  desktop: 'desktop',
});

/**
 * Минимально допустимая длина пароля при его смене в личном кабинете
 * @type {number}
 */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * Длина номера купона Много.ру для валидации в личном кабинете
 * @type {number}
 */
export const MNOGORU_COUPON_LENGTH = 8;

/**
 * Время ожидания для повторной отправки кода по смс
 * @type {number}
 */
export const SMS_RESENDING_TIMEOUT = 60 * 20 * 1000;

/**
 * Код РФ в формате ISO 3166-2
 * @type {string}
 */
export const ISO_CODE_RUSSIA = 'RU';

/**
 * Типы товаров в корзине
 * @type {Readonly<{cart: string, wishlist: string}>}
 * @const
 */
export const PRODUCT_CART_TYPES = Object.freeze({
  cart: 'cart',
  wishlist: 'wishlist',
});

/**
 * @typedef YandexAvatarSizes
 * @property {string} code - Код размера аватара
 */

/**
 * Список основных типов доставки
 * @readonly
 * @enum {YandexAvatarSizes}
 * @const
 */
export const YANDEX_AVATAR_SIZES = Object.freeze({
  'size-28x28': {
    code: 'islands-small',
  },
  'size-34x34': {
    code: 'islands-34',
  },
  'size-42x42': {
    code: 'islands-middle',
  },
  'size-50x50': {
    code: 'islands-50',
  },
  'size-56x56': {
    code: 'islands-retina-small',
  },
  'size-68x68': {
    code: 'islands-68',
  },
  'size-75x75': {
    code: 'islands-75',
  },
  'size-84x84': {
    code: 'islands-retina-middle',
  },
  'size-100x100': {
    code: 'islands-retina-50',
  },
  'size-200x200': {
    code: 'islands-200',
  },
});

/**
 * @typedef YandexGenders
 * @property {string} code - Код пола
 */

/**
 * Список полов в Яндексе
 * @readonly
 * @enum {YandexGenders}
 * @const
 */
export const YANDEX_GENDERS = Object.freeze({
  GENDER_MALE: {
    code: 'male',
  },
  GENDER_FEMALE: {
    code: 'female',
  },
});

/*
 * Номер телефона нашего кол-центра
 * @type {Array}
 */
export const CALL_CENTER_PHONE = [
  '8 (495) 268-08-41',
  '8 (800) 333-65-23',
];

/**
 * @typedef PaymentsType
 * @property {string} code - Код платёжной системы
 * @see PaymentSystemCodeEnum.php
 */

/**
 * Список платёжных систем
 * @readonly
 * @enum {PaymentsType}
 * @const
 */
export const PAYMENT_TYPES = Object.freeze({
  PL_SERVICE: {
    code: 'pl_service',
  },
  BONUS_ACCOUNT: {
    code: 'bonus_account',
  },
  CASH: {
    code: 'cash',
  },
  CARD_ONLINE: {
    code: 'cardonline',
  },
  YANDEX: {
    code: 'yandex',
  },
  YANDEX_KASSA: {
    code: 'yandex_kassa',
  },
  WEBMONEY: {
    code: 'webmoney',
  },
  ELECTRONIC_TERMINALS: {
    code: 'electronic_terminals',
  },
  QIWI: {
    code: 'qiwi',
  },
  SBERBANK: {
    code: 'sberbank',
  },
  CLOUD_PAYMENTS: {
    code: 'cloudpayments',
  },
  CLOUD_PAYMENTS_API: {
    code: 'cloudpayments_api',
  },
  CERTIFICATES_PAY: {
    code: 'certificates_pay',
  },
});

export const FORGOT_TEXT = 'Укажите адрес электронной почты, с которым вы регистрировались ранее, и мы вышлем инструкции по смене пароля.';
